import { useState } from "react";
import { Sidebar, Menu, MenuItem} from "react-pro-sidebar";
//import 'react-pro-sidebar/dist/css/styles.css';
import { Box, Button, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { tokens } from "../../theme";

import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import PieChartOutlineOutlinedIcon from '@mui/icons-material/PieChartOutlineOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';



const Item =({ title, to, icon, selected, setSelected}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <MenuItem 
            rootStyles={{
                // ".ps-menu-icon": {
                //     color: `${colors.primary[100]}`,
                //     backgroundColor: "transparent",
                // },
                // ".menu-text": {
                //     backgroundColor: "transparent !important",
                // },


                // ".ps-menu-button:hover": {
                //     backgroundColor: `${colors.primary[100]} !important`,
                // },
                // ".ps-menu-button:hover .menu-text": {
                //     backgroundColor: `${colors.primary[800]}`,
                //     color: `${colors.primary[800]}`,
                // },
                // ".ps-menu-button:hover .ps-menu-icon": {
                //     color: `${colors.primary[100]}`,
                // },


                // ".ps-menu-button.ps-active": {
                //     backgroundColor:`${colors.grey[100]}`
                // },
                // ".ps-menu-button.ps-active .menu-text": {
                //     backgroundColor: "transparent !important",
                //     Color: `${colors.blueAccent[500]} !important`,
                // },
                // ".ps-menu-button.ps-active .ps-menu-icon": {
                //     Color: `${colors.blueAccent[800]}`,
                // },


            }}
            active={selected === title}
            //style={{color: colors.grey[100]}}
            component={<Link to={to} />}
            onClick={() => setSelected(title)}
            icon={icon}    
        >
                <Typography /*className="menu-text"*/>{title}</Typography>
                {/* <Link to={to} /> */}
        </MenuItem>
    )
}

const MySidebar = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [selected, setSelected] = useState("Dashboard");

    return (
        <Box
            sx={{/*
                display: "flex",
                height: "100vh",
                "& .ps-sidebar-container" : {
                    background: `${colors.primary[400]} !important`, 
                },
                "& .ps-menu-icon" : {
                    backgroundColor: "transparent !important", 
                    //color:"#3a7ca9ff !important",
                },

                "& .ps-menu-button" : {
                    padding: "5px 35px 5px 20px !important",
                },
                "& .ps-menu-button:hover" : {
                    color: "#28282aff !important", 
                    //color: "#868dfb !important", 
                },
                "& .ps-menu-button:active" : {
                    //color: "#eb3110ff !important", 
                    color: "#6870fa !important",
                },
            */}}
        >
           <Sidebar collapsed={isCollapsed} 
                rootStyles={{ 
                    height: "100vh",

                    ".ps-sidebar-container": {
                        backgroundColor: colors.primary[400],
                    },

                    ".ps-menu-icon": {
                        backgroundColor: "transparent",
                    },
                    
                     }}>
                        <Menu 
                            menuItemStyles={{
                                button: {
                                    color: colors.grey[100], // لون النص العادي
                                    padding: "5px 35px 5px 20px",

                                    "& .ps-menu-icon": {
                                    color: colors.grey[100], // لون الأيقونة العادي
                                    },

                                    // Hover
                                    "&:hover": {
                                    backgroundColor: colors.grey[100], // خلفية عند المرور بالماوس
                                    color: colors.grey[800], // لون النص عند Hover
                                    "& .ps-menu-icon": {
                                        color: colors.grey[800], // لون الأيقونة عند Hover
                                    },
                                    "& .icon-btn": {
                                        color: colors.grey[800],
                                    },

                                    },

                                    // Active (عند الضغط أو العنصر المحدد)
                                    "& .ps-active": {
                                    backgroundColor: "#6870fa", // خلفية العنصر النشط
                                    color: "#ffffff", // لون النص للعنصر النشط

                                    "& .ps-menu-icon": {
                                        color: "#ffffff", // لون الأيقونة للعنصر النشط
                                    },
                                    },
                                },
                            }}
                        >
                            <MenuItem
                                onClick={() => setIsCollapsed(!isCollapsed)}
                                icon={isCollapsed ? <MenuOutlinedIcon/> : undefined}
                                style={{
                                    margin: "10px 0 20px 0",
                                }}
                            >
                                {!isCollapsed && (
                                    <Box
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        ml="15px"
                                    >
                                        <Typography 
                                            variant="h3" 
                                        >
                                            ADMINS
                                        </Typography>
                                        <IconButton 
                                            className="icon-btn"
                                            onClick={() => setIsCollapsed(!isCollapsed)}
                                        >
                                            <ListOutlinedIcon />
                                        </IconButton>
                                    </Box>
                                )}
                            </MenuItem>
                            {!isCollapsed && (
                                <Box mb="60px">
                                    <Box display="flex" justifyContent="center" alignItems="center">
                                        <img
                                            alt="profile-user"
                                            width="100px"
                                            height="100px"
                                            src={`../../logo512.png`}
                                            style={{ cursor: "pointer", borderRadius:"50%"}}
                                        />
                                    </Box>
                                    <Box textAlign="center">
                                        <Typography 
                                            variant="h2" 
                                            //color={colors.grey[100]} 
                                            fontWeight="bold" 
                                            sx={{m: "10px 0 0 0"}}
                                        >
                                            Mahmoud
                                        </Typography>
                                        <Typography
                                            variant="h5" 
                                            color={colors.greenAccent[500]}
                                        >
                                            Abd El Hafiz
                                        </Typography>
                                    </Box>
                                </Box>
                            )}

                            {/* Menu Items*/}
                            <Box paddingLeft={isCollapsed ? undefined : "10%"}>
                                <Item
                                    title="Dashboard"
                                    to="/"
                                    icon={<HomeOutlinedIcon/>}
                                    selected={selected}
                                    setSelected={setSelected}
                                />

                                <Typography
                                    variant="h6"
                                    color={colors.grey[300]}
                                    sx={{m:"15px 0 5px 20px"}}
                                >
                                        Data
                                </Typography>
                                <Item
                                    title="Manag team"
                                    to="/team"
                                    icon={<PeopleOutlinedIcon/>}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Contact information"
                                    to="/contacts"
                                    icon={<ContactsOutlinedIcon/>}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Invoices Balacnes"
                                    to="/invoices"
                                    icon={<ReceiptOutlinedIcon/>}
                                    selected={selected}
                                    setSelected={setSelected}
                                />

                                <Typography
                                    variant="h6"
                                    color={colors.grey[300]}
                                    sx={{m:"15px 0 5px 20px"}}
                                >
                                        Pages
                                </Typography>
                                <Item
                                    title="Profile Form"
                                    to="/form"
                                    icon={<PersonOutlineOutlinedIcon/>}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Calendar"
                                    to="/calendar"
                                    icon={<CalendarTodayOutlinedIcon/>}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="FAQ page"
                                    to="/faq"
                                    icon={<HelpOutlineOutlinedIcon/>}
                                    selected={selected}
                                    setSelected={setSelected}
                                />

                                <Typography
                                    variant="h6"
                                    color={colors.grey[300]}
                                    sx={{m:"15px 0 5px 20px"}}
                                >
                                        Charts
                                </Typography>
                                <Item
                                    title="Bar Chart"
                                    to="/bar"
                                    icon={<BarChartOutlinedIcon/>}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Pie chart"
                                    to="/pie"
                                    icon={<PieChartOutlineOutlinedIcon/>}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Line chart"
                                    to="/line"
                                    icon={<TimelineOutlinedIcon/>}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                                <Item
                                    title="Map"
                                    to="/geography"
                                    icon={<MapOutlinedIcon/>}
                                    selected={selected}
                                    setSelected={setSelected}
                                />
                            </Box>
                        </Menu>
           </Sidebar>

        </Box>
    );
}

export default MySidebar;